import React from 'react';
import moment from 'moment';
import { Typography } from 'antd';
import { TitleSections } from '../../../components/TitleSections';
import { TextAreaCustom } from '../../../components/TextAreaCustom';
import { TextSectiosTabs } from '../../../components/TitleSections/styles';

export function AnotacoesInternas({
  ultimaAtualizacaoObservacaoInterna,
  setObservacaoInterna,
  observacaoInterna,
}) {
  const ultimaAtualizacao = ultimaAtualizacaoObservacaoInterna
    ? moment(ultimaAtualizacaoObservacaoInterna).format(
        'DD/MM/YYYY, [às] HH:mm:ss'
      )
    : null;

  const { Text } = Typography;
  return (
    <>
      <TitleSections title="Observações Internas" />
      <TextSectiosTabs>
        <Text
          style={{
            fontSize: 14,
            visibility: ultimaAtualizacao ? 'visible' : 'hidden',
          }}
        >
          Atualizado pela última vez em:
{' '}
{ultimaAtualizacao}
        </Text>
      </TextSectiosTabs>
      <TextAreaCustom
        placeholder="Digite aqui"
        defaultValue={observacaoInterna}
        changeText={setObservacaoInterna}
        fontSize={12}
        maxRows={10}
        fullHeight={true}
        lengthText={Infinity}
      />
    </>
  );
}
